// extracted by mini-css-extract-plugin
export default {"loading":"PageStatus-loading-dd65","line":"PageStatus-line-a59d","loadingAnimation":"PageStatus-loadingAnimation-b499"};